import { COMPANY_API } from 'apis';

export const getQuickAgreement = async () => {
  const result = await COMPANY_API.get('/captain-payment/pass/v1/service/quick');
  return result.data;
};

export const stopUsingQuick = async () => {
  const result = await COMPANY_API.put('/captain-payment/service/v1', {
    serviceType: 'QUICK',
    status: 'INACTIVE'
  });
  return result;
};

export const startUsingQuick = async () => {
  const result = await COMPANY_API.put('/captain-payment/service/v1', {
    serviceType: 'QUICK',
    status: 'ACTIVE'
  });
  return result;
};

export const firstUseQuick = async () => {
  const result = await COMPANY_API.post('/captain-payment/pass/v1/service/quick');
  return result;
};
